<router-outlet></router-outlet>
<app-modal-not-allowed-access [isVisibleModal]="isVisibleModalNotAllowedAccess" (closed)="isVisibleModalNotAllowedAccess = false;"></app-modal-not-allowed-access>
